import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'
import Layout2 from '../views/layout/Layout2'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  }
]

export const asyncRouterMap = [
    {
    path: '/seting',
    component: Layout,
    redirect: '/seting',
    name: 'seting',
    meta: { title: '综合管理', icon: 'cms' },
    children: [
      {
        path: 'customer',
        name: 'customer',
        component: () => import('@/views/seting/customer/index'),
        meta: { title: '客户信息管理', icon: 'customer' }
      },
      {
        path: 'device',
        name: 'device',
        component: () => import('@/views/seting/device/index'),
        meta: { title: '设备基础信息' }, 
      },
      {
        path: 'contractNew',
        name: 'contractNew',
        component: () => import('@/views/seting/contractNew/index'),
        meta: { title: '合同管理', icon: 'contract' }
      },
      {
        path: 'course',
        name: 'course',
        component: () => import('@/views/seting/course/index'),
        meta: { title: '维修报价目录', icon: 'course' }
      }, 
      {
        path: 'servicing',
        name: 'servicing',
        component: () => import('@/views/seting/servicing/index'),
        meta: { title: '维修科目', icon: 'servicing' }
      },
      {
        path: 'repairLevel',
        name: 'repairLevel',
        component: () => import('@/views/seting/repairLevel/index'),
        meta: { title: '维修员等级配置', icon: 'ums-admin' }
      }
    ]
  }, {
    path: '/salary',
    component: Layout,
    redirect: '/salary',
    name: 'salary',
    meta: { title: '薪酬绩效', icon: 'salary' },
    children: [
      {
        path: 'tesks',
        name: 'tesks',
        component: () => import('@/views/salary/task'),
        meta: { title: '任务完成统计' }
      },
      {
        path: 'salarys',
        name: 'salarys',
        component: () => import('@/views/salary/salarys'),
        meta: { title: '岗位工资管理' }
      },
      {
        path: 'bonus',
        name: 'bonus',
        component: () => import('@/views/salary/bonus'),
        meta: { title: '岗位奖金管理' }
      },
      {
        path: 'performance',
        name: 'performance',
        component: () => import('@/views/performance/performance'),
        meta: { title: '绩效明细表' }
      },
      {
        
        path: '/performance/oaperformances',
        redirect: '/oaperformances',
        component: Layout2, 
        name: 'oaperformances',
        meta: { title: '绩效异常处理' }, 
        children: [
          {
            path: 'performances_flow',
            name: 'performances_flow',
            component: () => import('@/views/performance/flow'),
            meta: { title: '待办申请' },
          },
          {
            path: 'performances_flow_do',
            name: 'performances_flow_do',
            component: () => import('@/views/performance/doflow'),
            meta: { title: '办理工单' },
            hidden: true
          },
          {
            path: 'performances_flow_all',
            name: 'performances_flow_all',
            component: () => import('@/views/performance/all'),
            meta: { title: '申请流程监控' }
          },
          {
            path: 'performances_completed',
            name: 'performances_completed',
            component: () => import('@/views/performance/completed'),
            meta: { title: '办结申请' }
          }, 
          {
            path: 'performances_view',
            name: 'performances_view',
            component: () => import('@/views/performance/view'),
            meta: { title: '申请详情' },
            hidden: true
          }
        ]
      },
      {
        path: 'salarytotal',
        name: 'salarytotal',
        component: () => import('@/views/salary/salarytotal'),
        meta: { title: '薪酬统计表' }
      },
      {
        
        path: '/salary/dissent',
        redirect: '/salary',
        component: Layout2, 
        name: 'dissent',
        meta: { title: '薪酬异常处理' }, 
        children: [
          {
            path: 'dissent_flow',
            name: 'dissent_flow',
            component: () => import('@/views/salary/flow'),
            meta: { title: '待办申请' },
          },
          {
            path: 'dissent_flow_do',
            name: 'dissent_flow_do',
            component: () => import('@/views/salary/doflow'),
            meta: { title: '办理工单' },
            hidden: true
          },
          {
            path: 'dissent_flow_all',
            name: 'dissent_flow_all',
            component: () => import('@/views/salary/all'),
            meta: { title: '申请流程监控' }
          },
          {
            path: 'dissent_completed',
            name: 'dissent_completed',
            component: () => import('@/views/salary/completed'),
            meta: { title: '办结申请' }
          }, 
          {
            path: 'dissent_view',
            name: 'dissent_view',
            component: () => import('@/views/salary/view'),
            meta: { title: '申请详情' },
            hidden: true
          }
        ]
      }
    ]
  }, {
    path: '/notice',
    component: Layout,
    redirect: '/notice',
    name: 'notice',     
    meta: { title: '通知公告', icon: 'notice' },
    children: [
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/notice/index'),
        meta: { title: '通知公告', icon: 'atta' },
        hidden: true
      },
      {
        path: 'addNotice',
        name: 'addNotice',
        component: () => import('@/views/notice/add'),
        meta: { title: '添加通知公告' },
        hidden: true
      },
      {
        path: 'updateNotice',
        name: 'updateNotice',
        component: () => import('@/views/notice/update'),
        meta: { title: '编辑通知公告' },
        hidden: true
      }
    ]
  }, {
    path: '/repair',
    component: Layout,
    redirect: '/repair',
    name: 'repair',
    meta: { title: '故障报修', icon: 'repair' },
    children: [
      {
      path: 'repair_add',
      name: 'repair_add',
      component: () => import('@/views/repair/add'),
      meta: { title: '快速报修', icon: 'atta' }
      },
      {
        path: 'repair_index',
        name: 'repair_index',
        component: () => import('@/views/repair/index'),
        meta: { title: '故障报修清单', icon: 'atta' }
      },
      {
        path: 'repair_flow',
        name: 'repair_flow',
        component: () => import('@/views/repair/flow'),
        meta: { title: '待办工单' }
      },
      {
        path: 'repair_flow_do',
        name: 'repair_flow_do',
        component: () => import('@/views/repair/doflow'),
        meta: { title: '办理工单' },
        hidden: true
      },
      {
        path: 'repair_flow_all',
        name: 'repair_flow_all',
        component: () => import('@/views/repair/all'),
        meta: { title: '工单监控' },
        hidden: true
      },
      {
        path: 'repair_completed',
        name: 'repair_completed',
        component: () => import('@/views/repair/completed'),
        meta: { title: '办结工单' },
        hidden: true
      },
      {
        path: 'repair_statistics',
        name: 'repair_statistics',
        component: () => import('@/views/repair/statistics'),
        meta: { title: '\u62a5\u4fee\u7edf\u8ba1' }
      },
      {
        path: 'view',
        name: 'view',
        component: () => import('@/views/repair/view'),
        meta: { title: '工单详情' },
        hidden: true
      },
      {
        path: 'repair_back',
        name: 'repair_back',
        component: () => import('@/views/repair/del'),
        meta: { title: '回收站', icon: 'atta' }
      },
    ]
  },{
    path: '/inspectors',
    component: Layout,
    redirect: '/inspectors',
    name: 'inspectors',
    meta: { title: '定期工作任务', icon: 'inspectors' },
    children: [
      {
        path: 'ins_config',
        name: 'ins_config',
        component: () => import('@/views/inspectors/config'),
        meta: { title: '定期任务', icon: 'atta' },
        hidden: true
      },
      {
        path: 'ins_index',
        name: 'ins_index',
        component: () => import('@/views/inspectors/index'),
        meta: { title: '任务清单', icon: 'atta' },
        hidden: true
      },
      {
        path: 'ins_flow',
        name: 'ins_flow',
        component: () => import('@/views/inspectors/flow'),
        meta: { title: '待办工单' },
        hidden: true
      },
      {
        path: 'ins_flow_do',
        name: 'ins_flow_do',
        component: () => import('@/views/inspectors/doflow'),
        meta: { title: '办理工单' },
        hidden: true
      },
      {
        path: 'ins_flow_all',
        name: 'ins_flow_all',
        component: () => import('@/views/inspectors/all'),
        meta: { title: '工单监控' },
        hidden: true
      },
      {
        path: 'ins_completed',
        name: 'ins_completed',
        component: () => import('@/views/inspectors/completed'),
        meta: { title: '办结工单' },
        hidden: true
      }, 
      {
        path: 'ins_view',
        name: 'ins_view',
        component: () => import('@/views/inspectors/view'),
        meta: { title: '工单详情' },
        hidden: true
      }
    ]
  },{
    path: '/goods',
    component: Layout,
    redirect: '/goods',
    name: 'goods',
    meta: { title: '物资管理', icon: 'goods' },
    children: [
      {
        path: 'goods_cate',
        name: 'goods_cate',
        component: () => import('@/views/goods/cate'),
        meta: { title: '物资分类', icon: 'atta' },
      },
      {
        path: 'goods_index',
        name: 'goods_index',
        component: () => import('@/views/goods/index'),
        meta: { title: '物资库存管理' },
      },
      {
        path: 'goods_gw',
        name: 'goods_gw',
        component: () => import('@/views/goods/goodsGw/index'),
        meta: { title: '总库存' },
      },
      {
        path: 'stock/stockInList',
        name: 'stockInList',
        component: () => import('@/views/goods/stock/stockInList'),
        meta: { title: '其他入库单' },
      },
      {
        path: 'stock/stockInAdd',
        name: 'stockInAdd',
        component: () => import('@/views/goods/stock/stockInAdd'),
        meta: { title: '新增入库单' },
        hidden: true
      },
      {
        path: 'stock/stockOutList',
        name: 'stockOutList',
        component: () => import('@/views/goods/stock/stockOutList'),
        meta: { title: '其他出库单' },
      },
      {
        path: 'stock/stockOutAdd',
        name: 'stockOutAdd',
        component: () => import('@/views/goods/stock/stockOutAdd'),
        meta: { title: '新增出库单' },
        hidden: true
      },
      {
        path: 'stock/stockRecord',
        name: 'stockRecord',
        component: () => import('@/views/goods/stock/stockRecord'),
        meta: { title: '出入库明细' },
        hidden: true
      },
      {
        path: 'stock/stockRecordDetail',
        name: 'stockRecordDetail',
        component: () => import('@/views/goods/stock/stockRecordDetail'),
        meta: { title: '出入库明细页面' },
        hidden: true
      },
      {
        path: 'price_show',
        name: 'price_show',
        component: () => import('@/views/goods/index2'),
        meta: { title: '价格查看' },
        hidden: true
      },
      {
        path: 'in_goods',
        name: 'in_goods',
        component: () => import('@/views/goods/in_goods'),
        meta: { title: '入库明细' },
        hidden: true
      },
      {
        path: 'out_goods',
        name: 'out_goods',
        component: () => import('@/views/goods/out_goods'),
        meta: { title: '出库明细' },
        hidden: true
      },
      {
        path: '/goods/goods_use',
        redirect: '/goods_use',
        component: Layout2,
        name: 'goods_use',
        meta: { title: '物料申领' }, 
        children: [
          {
            path: 'goods_use_add',
            name: 'goods_use_add',
            component: () => import('@/views/goods/goods_use/add'),
            meta: { title: '物料申请', icon: 'atta' }
          },
          {
            path: 'goods_use_index',
            name: 'goods_use_index',
            component: () => import('@/views/goods/goods_use/index'),
            meta: { title: '物资申领清单', icon: 'atta' },
          },
          {
            path: 'goods_use_update',
            name: 'goods_use_update',
            component: () => import('@/views/goods/goods_use/update'),
            meta: { title: '编辑申请', icon: 'atta' },
            hidden: true
          },
          {
            path: 'goods_use_flow',
            name: 'goods_use_flow',
            component: () => import('@/views/goods/goods_use/flow'),
            meta: { title: '待办申请' },
          },
          {
            path: 'goods_use_flow_do',
            name: 'goods_use_flow_do',
            component: () => import('@/views/goods/goods_use/doflow'),
            meta: { title: '办理工单' },
            hidden: true
          },
          {
            path: 'goods_use_flow_all',
            name: 'goods_use_flow_all',
            component: () => import('@/views/goods/goods_use/all'),
            meta: { title: '申请流程监控' },
            hidden: true
          },
          {
            path: 'goods_use_completed',
            name: 'goods_use_completed',
            component: () => import('@/views/goods/goods_use/completed'),
            meta: { title: '办结申请' },
            hidden: true
          }, 
          {
            path: 'goods_use_view',
            name: 'goods_use_view',
            component: () => import('@/views/goods/goods_use/view'),
            meta: { title: '申请详情' },
            hidden: true
          }
        ]
      },,
      {
        path: '/goods/goods_buy',
        redirect: '/goods_buy',
        component: Layout2,
        name: 'goods_buy',
        meta: { title: '物料申购' }, 
        children: [
          {
            path: 'goods_buy_add',
            name: 'goods_buy_add',
            component: () => import('@/views/goods/goods_buy/add'),
            meta: { title: '物料申购', icon: 'atta' }
          },
          {
            path: 'goods_buy_index',
            name: 'goods_buy_index',
            component: () => import('@/views/goods/goods_buy/index'),
            meta: { title: '物料申购清单', icon: 'atta' },
          },
          {
            path: 'goods_buy_update',
            name: 'goods_buy_update',
            component: () => import('@/views/goods/goods_buy/update'),
            meta: { title: '编辑申请', icon: 'atta' },
            hidden: true
          },
          {
            path: 'goods_buy_flow',
            name: 'goods_buy_flow',
            component: () => import('@/views/goods/goods_buy/flow'),
            meta: { title: '待办申请' },
          },
          {
            path: 'goods_buy_flow_do',
            name: 'goods_buy_flow_do',
            component: () => import('@/views/goods/goods_buy/doflow'),
            meta: { title: '办理工单' },
            hidden: true
          },
          {
            path: 'goods_buy_flow_all',
            name: 'goods_buy_flow_all',
            component: () => import('@/views/goods/goods_buy/all'),
            meta: { title: '申请流程监控' },
            hidden: true
          },
          {
            path: 'goods_buy_completed',
            name: 'goods_buy_completed',
            component: () => import('@/views/goods/goods_buy/completed'),
            meta: { title: '办结申请' },
            hidden: true
          }, 
          {
            path: 'goods_buy_view',
            name: 'goods_buy_view',
            component: () => import('@/views/goods/goods_buy/view'),
            meta: { title: '申请详情' },
            hidden: true
          }
        ]
      },
      {
        path: '/goods/user_use',
        redirect: '/user_use',
        component: Layout2,
        name: 'user_use',
        meta: { title: '员工物资申领' }, 
        children: [
          {
            path: 'user_use_add',
            name: 'user_use_add',
            component: () => import('@/views/goods/user_use/add'),
            meta: { title: '员工物资申领', icon: 'atta' },
          },
          {
            path: 'user_use_index',
            name: 'user_use_index',
            component: () => import('@/views/goods/user_use/index'),
            meta: { title: '物资申领清单', icon: 'atta' },
          },
          {
            path: 'user_use_update',
            name: 'user_use_update',
            component: () => import('@/views/goods/user_use/update'),
            meta: { title: '编辑申请', icon: 'atta' },
            hidden: true
          },
          {
            path: 'user_use_flow',
            name: 'user_use_flow',
            component: () => import('@/views/goods/user_use/flow'),
            meta: { title: '待办申请' },
          },
          {
            path: 'user_use_flow_do',
            name: 'user_use_flow_do',
            component: () => import('@/views/goods/user_use/doflow'),
            meta: { title: '办理工单' },
            hidden: true
          },
          {
            path: 'user_use_flow_all',
            name: 'user_use_flow_all',
            component: () => import('@/views/goods/user_use/all'),
            meta: { title: '申请流程监控' },
            hidden: true
          },
          {
            path: 'user_use_completed',
            name: 'user_use_completed',
            component: () => import('@/views/goods/user_use/completed'),
            meta: { title: '办结申请' },
            hidden: true
          }, 
          {
            path: 'user_use_view',
            name: 'user_use_view',
            component: () => import('@/views/goods/user_use/view'),
            meta: { title: '申请详情' },
            hidden: true
          }
        ]
      }
    ]
  }, {
    path: '/total',
    component: Layout,
    redirect: '/total',
    name: 'total',     
    meta: { title: '统计分析', icon: 'total' },
    children: [
      {
        path: 'repair_total',
        name: 'repair_total',
        component: () => import('@/views/repair/total'),
        meta: { title: '任务完成统计' },
      },
      {
        path: 'contract_total',
        name: 'contract_total',
        component: () => import('@/views/total/contract_total'),
        meta: { title: '合同回款统计' },
      }
    ]
  }, {
    path: '/ums',
    component: Layout,
    redirect: '/ums/user', 
    name: 'ums',
    meta: { title: '系统管理', icon: 'ums' },
    children: [
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: 'ums-admin' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: 'ums-role' }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: { title: '分配菜单' },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: 'ums-menu' }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: { title: '添加菜单' },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
        hidden: true
      },
      {
        path: 'values',
        name: 'values',
        component: () => import('@/views/ums/values/index'),
        meta: { title: '数据字典', icon: 'values' }
      },
      {
        path: 'flow',
        name: 'flow',
        component: () => import('@/views/ums/flow/index'),
        meta: { title: '流程管理', icon: 'flow' }
      },
      {
        path: 'flowset',
        name: 'flowset',
        component: () => import('@/views/ums/flow/set'),
        meta: { title: '流程设置', icon: 'flow' },
        hidden: true
      },
      {
        path: 'updataflow',
        name: 'updataflow',
        component: () => import('@/views/ums/flow/updata'),
        meta: { title: '流程设置', icon: 'flow' },
        hidden: true
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js